import { render, staticRenderFns } from "./OperaSystemProjectDetailWindow.vue?vue&type=template&id=1fe7ae2e&scoped=true&"
import script from "./OperaSystemProjectDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaSystemProjectDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaSystemProjectDetailWindow.vue?vue&type=style&index=0&id=1fe7ae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7ae2e",
  null
  
)

export default component.exports